import { Placa } from "@/types/placa";

export const novaPlaca = (): Placa => {
  return {
    placa: "",
  }
}